export default class VideoControls {
    constructor(element) {
        this.video = element;
        this.container = element.parentElement;

        const controls = this.container.querySelector('.o-media-container__controls');
        this.style = controls ? controls.dataset.style : '';

        // For animated progress
        if(this.style == "compact") {
            this.border = this.container.querySelector('[data-progress-border]');
            this.setBorderLength();
        } else {
            this.seek = this.container.querySelector('[data-progress]');
            this.fullscreen = this.container.querySelector('[data-fullscreen]');
        }

        this.bindEvents();
        this.setVideoState('is-paused');
    }

    setBorderLength() {
        if (this.border.getBBox().width > 0) {
            this.borderDashArray = this.border.getTotalLength();
            this.border.style.strokeDasharray = this.borderDashArray;
        } else {
            document.addEventListener('ajaxModalHasLoaded', () => {
                this.setBorderLength()
            }, { once: true });
        }
    }

    bindEvents() {
        const video = this.video;
        const container = this.container;
        const seek = this.seek;
        const playPause = container.querySelector('[data-toggle]');

        playPause.addEventListener('click', () => {
            if (video.paused || video.ended) {
                video.play();
                playPause.setAttribute('aria-label', 'Pause');
                playPause.setAttribute('aria-pressed', 'true');
            } else {
                video.pause();
                playPause.setAttribute('aria-label', 'Play');
                playPause.setAttribute('aria-pressed', 'false');
            }
        });

        video.addEventListener('loadedmetadata', () => this.updateProgressDisplay());
        video.addEventListener('timeupdate', () => this.updateProgressDisplay());

        video.addEventListener('play', () => {
            this.setVideoState('is-playing');
        });

        video.addEventListener('pause', () => {
            this.setVideoState('is-paused');
        });

        video.addEventListener('ended', () => {
            this.setVideoState('is-ended');
        });

        video.addEventListener('waiting', () => {
            container.classList.add('is-buffering');
        });

        video.addEventListener('playing', () => {
            container.classList.remove('is-buffering');
        });

        if(this.style == "full") {
            seek.addEventListener('input', () => {
                video.currentTime = seek.value;
                seek.style.setProperty('--progress', (seek.value / seek.max) * 100 + '%');
            });

            this.fullscreen.addEventListener('click', () => {
                if (!document.fullscreenElement) {
                    video.parentElement.requestFullscreen();
                } else {
                    document.exitFullscreen();
                }
            });
        }

        // Keyboard accessibility: spacebar to play/pause
        window.addEventListener('keydown', (e) => {
            if (e.code === 'Space' && document.activeElement === playPause) {
                e.preventDefault();
                playPause.click();
            }
        });
    }

    updateProgressDisplay() {
        const video = this.video;

        if(this.style == "compact") {
            const duration = video.duration;
            const currentTime = video.currentTime;
            const progress = duration > 0 ? (currentTime / duration) * 100 : 0;
            const offset = this.borderDashArray - (this.borderDashArray * progress) / 100;
            this.border.style.strokeDashoffset = offset;
        } else {
            const seek = this.seek;
            seek.value = video.currentTime;
            seek.max = video.duration;
            seek.style.setProperty('--progress', (seek.value / seek.max) * 100 + '%');
        }
    }

    setVideoState(...states) {
        this.container.classList.remove('is-playing', 'is-paused', 'is-ended', 'is-buffering');
        this.container.classList.add(...states);
    }
}